import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

export interface SendTestSmsInput {
  to: string;
  body: string;
}

export interface SendTestSmsResponse {
  success: boolean;
  message: string;
}

export class SmsService {
  constructor(private readonly axios: AxiosInstance = axiosInstance) {}

  async sendTestSms(data: SendTestSmsInput): Promise<SendTestSmsResponse> {
    const response = await this.axios.post<SendTestSmsResponse>(ENDPOINTS.SMS.SEND, data);
    return response.data;
  }
}
